import $ from "jquery";
import {triggerEvent} from "./browser-util";
export {
	slideToggle,
	readMore,
	openModal,
	closeModal,
	slideCalendar,
	goUpgrade,
	scrollWindow
};

function slideToggle() {
	let $iconEl = $(this).find(".tglSld_iconWT");
	if (!$iconEl.length) {
		$iconEl = $(this).find(".tglSld_iconRD");
	}
	const $target = $(this).next();
	const SPEED = 300;
	if ($target.is(":visible")) {
		$iconEl.addClass("close").removeClass("open");
	} else {
		$iconEl.addClass("open").removeClass("close");
	}
	$target.slideToggle(SPEED);
}

function openModal(ev) {
	ev.preventDefault();
	const group = this.dataset.group;
	$(".modal_wrap").each(function(){
		if (group === this.dataset.group) {
			$(this).fadeIn();
		}
	});
}
function closeModal(ev) {
	ev.preventDefault();
	$(".modal_wrap").fadeOut();
}

function readMore() {
	$(this).hide().next().show();
}

function slideCalendar(ev, target) {
	let nextMonthIndex, $calendar;
	if (target) {
		nextMonthIndex = target.index,
		$calendar = $(target.selector);
	}
	if (!$calendar || !(nextMonthIndex >= 0)) {
		nextMonthIndex = $(this).data("monthidx");
		$calendar = $(this).closest(".ipt_calWrap");
	}
	if ($calendar[0] && nextMonthIndex >= 0) {
		$calendar.css({left: `-${nextMonthIndex * 100}%`});
	}
}

function scrollWindow(ev) {
	ev.preventDefault();
	const href = $(this).attr("href");
	const target = $(href === "#" || href === "" ? "html" : href);
	const position = target.offset().top;
	const SPEED = 800;
	$("html, body").animate({scrollTop: position}, SPEED);
}

function goUpgrade() {
	// hidden を開ける処理を挟む必要があるので、scrollWindow とは別に定義する
	const grade = ($(this).attr("class").match(/go_upgrade_(PY|C|F)/))[1];
	const id = "upgrade" + grade;
	if($("#osusume_hidden").find("#" + id).length){
		$(".forcia-readmore").click();
	}
	$("#" + id).parent("p").next("div").show();
	$("#" + id).removeClass("close").addClass("open");
	const position = $("#" + id).offset().top;
	const SPEED = 800;
	$("html, body").animate({scrollTop: position}, SPEED);
}

export const flickCal = {
	// touchstartとtouchendを使って独自flickイベントを定義
	events: {
		"touchstart": function() {
			$(this).data("startX", event.changedTouches[0].pageX);
			$(this).data("startTime", +new Date());
		},
		"touchend": function() {
			const diffX = event.changedTouches[0].pageX - $(this).data("startX");
			const diffTime = +new Date() - $(this).data("startTime");
			if (Math.abs(diffX) > 50 && diffTime < 400) {
				if (diffX > 0) {
					$(this).trigger("myflickprev");
				} else {
					$(this).trigger("myflicknext");
				}
			}
		}
	},
	prev: function() {
		const elm = $(this).find(".ipt_calBox_navItem.prev a")[0];
		triggerEvent(elm, "click");
	},
	next: function() {
		const elm = $(this).find(".ipt_calBox_navItem.next a")[0];
		triggerEvent(elm, "click");
	}
};




// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/animation.js